import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsShenzhenmetroComponent } from './simple-icons-shenzhenmetro.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsShenzhenmetroComponent ],
    exports:      [ SimpleIconsShenzhenmetroComponent ],
    bootstrap:    []
})
export class SimpleIconsShenzhenmetroModule {}
